import React from "react";
import { GrDirections } from "react-icons/gr";
// import { Link } from 'react-router-dom';
import {
  Popup,
  //Button,
} from "semantic-ui-react";

const QuickLink = () => {

  //*************** */
  const renderPopupState = () => {
    if (window.innerWidth < 600) {
      return true;
    }
    if (window.innerWidth > 600) {
      return false;
    }
  };
  //^^^^^^^^^^
  const renderDirectionButton = (add) => (
    <Popup
      content={"Get directions to this location on Google Map "}
      disabled={renderPopupState()}
      trigger={
        <a target="_blank" rel="noreferrer noopener" className="bt font-16B" href={`${add}`}
		
		>
          <GrDirections className="font-16B" />{" "}
          Directions
        </a>
      }
    />
  );
  //*************** */
  return (
    <section>
      
          <div className="flex-center direction-c font-family-Nunito "
          style={{background:'whitesmoke',color:'rgba(0, 0, 0, 0.9)', padding:'10px 20px 50px'}}
          >
            
        <div className="flex-center" style={{}}>
            <div className="flex-value-footer">
					<img src="/logo.png"alt=" " style={{width:"150px", height:"50px",borderRadius:'5px',verticalAlign:'middle'}}/>
					<p>We are a reputed real estate firm, Totally committed to ethical business practices with true &amp; loyal dealings which are very rare in this field of business.</p>	
				</div>
			
			
				{/* <div className="flex-value-footer" >
					<h3>Address </h3> */}
					
					<p className="flex-value-footer"style={{alignSelf:'flex-start'}}> <b>HEAD OFFICE</b> <br/>Plot No 485-486 Sector 19 <br/>Dwarka New Delhi 110075<br/>Near ICICI Bank And Opp Max Hospital<br/>
					{renderDirectionButton('https://maps.app.goo.gl/k1btpuBwNarM1R5E6')}
					<br/></p>
					<p className="flex-value-footer" style={{alignSelf:'flex-start'}}><b>BRANCH OFFICE</b><br/>Rajendra Park Main <br/> Dwarka Expressway <br/>Sector 105 Gurugram 122001 <br/>Opp Paras Dews <br/>
					{renderDirectionButton('https://maps.app.goo.gl/1sCseaPJzKM3mXTJ7')}
					</p>

				
				{/* </div> */}
			
				</div>

			<div className="">
						<p>Copyright © 2020. All rights reserved</p>
					</div>
		
  
          </div>
       
    </section>
  );

};

export default QuickLink;
